import { ONBOARDING_FLOW } from '@frontend/product-onboarding';
import { pendo } from '@frontend/tracking';

const BASE_ONBOARDING_ID = ONBOARDING_FLOW.CI_BASE.id;
const PRO_ONBOARDING_ID = ONBOARDING_FLOW.CI_PRO.id;

export const CI_PRO_ONBOARDING_EVENTS = {
  bannerSeen: `${PRO_ONBOARDING_ID}:onboarding-banner-seen`,
  bannerAutoDismissed: `${PRO_ONBOARDING_ID}:onboarding-banner-auto-dismissed`,

  checklistAutoOpened: `${PRO_ONBOARDING_ID}:onboarding-checklist-auto-opened`,
  checklistNudgeOpened: `${PRO_ONBOARDING_ID}:onboarding-checklist-nudge-opened`,
  checklistSeen: `${PRO_ONBOARDING_ID}:onboarding-checklist-seen`,
  checklistCompleted: `${PRO_ONBOARDING_ID}:onboarding-checklist-completed`,
  checklistExpiredIncomplete: `${PRO_ONBOARDING_ID}:onboarding-checklist-expired-incomplete`,
  checklistExpiredComplete: `${PRO_ONBOARDING_ID}:onboarding-checklist-expired-complete`,

  taskCompleted: {
    overviewInsights: `${PRO_ONBOARDING_ID}:onboarding-overview-insights-task-completed`,
    overviewChartDrilldown: `${PRO_ONBOARDING_ID}:onboarding-overview-chart-drilldown-task-completed`,
    viewCallInsights: `${PRO_ONBOARDING_ID}:onboarding-view-call-insights-task-completed`,
    reviewConversationAnalysis: `${PRO_ONBOARDING_ID}:onboarding-review-conversation-analysis-task-completed`,
    viewFollowUpTasks: `${PRO_ONBOARDING_ID}:onboarding-view-follow-up-tasks-task-completed`,
    viewPatientContext: `${PRO_ONBOARDING_ID}:onboarding-view-patient-context-task-completed`,
    assignUserRoles: `${PRO_ONBOARDING_ID}:onboarding-assign-user-roles-task-completed`,
  },

  hotspotSeen: {
    activeOpportunitiesInfoIcon: `${PRO_ONBOARDING_ID}:onboarding-active-opportunities-info-icon-hotspot-seen`,
    unhappyCallsChartSegment: `${PRO_ONBOARDING_ID}:onboarding-unhappy-calls-chart-segment-hotspot-seen`,
    unhappyCallsChartSegmentFallback: `${PRO_ONBOARDING_ID}:onboarding-unhappy-calls-chart-segment-fallback-hotspot-seen`,
    callInsightButton: `${PRO_ONBOARDING_ID}:onboarding-call-insight-button-hotspot-seen`,
    transcriptTab: `${PRO_ONBOARDING_ID}:onboarding-transcript-tab-hotspot-seen`,
    callBreakdownAccordion: `${PRO_ONBOARDING_ID}:onboarding-call-breakdown-accordion-hotspot-seen`,
    makeCorrectionButton: `${PRO_ONBOARDING_ID}:onboarding-make-correction-button-hotspot-seen`,
    callLevelFeedback: `${PRO_ONBOARDING_ID}:onboarding-call-level-feedback-hotspot-seen`,
    followUpTasksTab: `${PRO_ONBOARDING_ID}:onboarding-follow-up-tasks-tab-hotspot-seen`,
    schedulingTasksListButton: `${PRO_ONBOARDING_ID}:onboarding-scheduling-tasks-list-button-hotspot-seen`,
    allFollowUpsListButtonFallback: `${PRO_ONBOARDING_ID}:onboarding-all-follow-ups-list-button-fallback-hotspot-seen`,
    patientAvatar: `${PRO_ONBOARDING_ID}:onboarding-patient-avatar-hotspot-seen`,
    lastCallCard: `${PRO_ONBOARDING_ID}:onboarding-last-call-card-hotspot-seen`,
    viewHistoryButton: `${PRO_ONBOARDING_ID}:onboarding-view-history-button-hotspot-seen`,
    settingsIcon: `${PRO_ONBOARDING_ID}:onboarding-settings-icon-hotspot-seen`,
    userManagementNav: `${PRO_ONBOARDING_ID}:onboarding-user-management-nav-hotspot-seen`,
  },

  tooltipSeen: {
    activeOpportunities: `${PRO_ONBOARDING_ID}:onboarding-active-opportunities-tooltip-seen`,
    transcriptTab: `${PRO_ONBOARDING_ID}:onboarding-transcript-tab-tooltip-seen`,
    classifications: `${PRO_ONBOARDING_ID}:onboarding-classifications-tooltip-seen`,
    editAiView: `${PRO_ONBOARDING_ID}:onboarding-edit-ai-view-tooltip-seen`,
    feedbackModal: `${PRO_ONBOARDING_ID}:onboarding-feedback-modal-tooltip-seen`,
    followUpTask: `${PRO_ONBOARDING_ID}:onboarding-follow-up-task-tooltip-seen`,
    lastCallCard: `${PRO_ONBOARDING_ID}:onboarding-last-call-card-tooltip-seen`,
    patientHistoryCall: `${PRO_ONBOARDING_ID}:onboarding-patient-history-call-tooltip-seen`,
    userTableAction: `${PRO_ONBOARDING_ID}:onboarding-user-table-action-tooltip-seen`,
  },
} as const;

export const CI_BASE_ONBOARDING_EVENTS = {
  bannerSeen: `${BASE_ONBOARDING_ID}:onboarding-banner-seen`,
  bannerAutoDismissed: `${BASE_ONBOARDING_ID}:onboarding-banner-auto-dismissed`,

  checklistAutoOpened: `${BASE_ONBOARDING_ID}:onboarding-checklist-auto-opened`,
  checklistNudgeOpened: `${BASE_ONBOARDING_ID}:onboarding-checklist-nudge-opened`,
  checklistSeen: `${BASE_ONBOARDING_ID}:onboarding-checklist-seen`,
  checklistCompleted: `${BASE_ONBOARDING_ID}:onboarding-checklist-completed`,
  checklistExpiredIncomplete: `${BASE_ONBOARDING_ID}:onboarding-checklist-expired-incomplete`,
  checklistExpiredComplete: `${BASE_ONBOARDING_ID}:onboarding-checklist-expired-complete`,

  taskCompleted: {
    viewCallInsights: `${BASE_ONBOARDING_ID}:onboarding-view-call-insights-task-completed`,
    viewPatientContext: `${BASE_ONBOARDING_ID}:onboarding-view-patient-context-task-completed`,
    assignUserRoles: `${BASE_ONBOARDING_ID}:onboarding-assign-user-roles-task-completed`,
  },

  hotspotSeen: {
    callsNavigation: `${BASE_ONBOARDING_ID}:onboarding-calls-navigation-hotspot-seen`,
    callInsightButton: `${BASE_ONBOARDING_ID}:onboarding-call-insight-button-hotspot-seen`,
    transcriptTab: `${BASE_ONBOARDING_ID}:onboarding-transcript-tab-hotspot-seen`,
    patientAvatar: `${BASE_ONBOARDING_ID}:onboarding-patient-avatar-hotspot-seen`,
    lastCallCard: `${BASE_ONBOARDING_ID}:onboarding-last-call-card-hotspot-seen`,
    viewHistoryButton: `${BASE_ONBOARDING_ID}:onboarding-view-history-button-hotspot-seen`,
    settingsIcon: `${BASE_ONBOARDING_ID}:onboarding-settings-icon-hotspot-seen`,
    userManagementNav: `${BASE_ONBOARDING_ID}:onboarding-user-management-nav-hotspot-seen`,
  },

  tooltipSeen: {
    transcriptTab: `${BASE_ONBOARDING_ID}:onboarding-transcript-tab-tooltip-seen`,
    lastCallCard: `${BASE_ONBOARDING_ID}:onboarding-last-call-card-tooltip-seen`,
    patientHistoryCall: `${BASE_ONBOARDING_ID}:onboarding-patient-history-call-tooltip-seen`,
    userTableAction: `${BASE_ONBOARDING_ID}:onboarding-user-table-action-tooltip-seen`,
  },
} as const;

export const CI_PRO_ONBOARDING_TRACKING_IDS = {
  bannerShowMeAroundClick: `${PRO_ONBOARDING_ID}:onboarding-banner-show-me-around-click`,
  bannerDismissClick: `${PRO_ONBOARDING_ID}:onboarding-banner-dismiss-click`,

  getStartedNavClick: `${PRO_ONBOARDING_ID}:onboarding-get-started-nav-click`,

  taskNavigationClick: {
    overviewInsights: `${PRO_ONBOARDING_ID}:onboarding-overview-insights-nav-click`,
    overviewChartDrilldown: `${PRO_ONBOARDING_ID}:onboarding-overview-chart-drilldown-nav-click`,
    viewCallInsights: `${PRO_ONBOARDING_ID}:onboarding-view-call-insights-nav-click`,
    reviewConversationAnalysis: `${PRO_ONBOARDING_ID}:onboarding-review-conversation-analysis-nav-click`,
    viewFollowUpTasks: `${PRO_ONBOARDING_ID}:onboarding-view-follow-up-tasks-nav-click`,
    viewPatientContext: `${PRO_ONBOARDING_ID}:onboarding-view-patient-context-nav-click`,
    assignUserRoles: `${PRO_ONBOARDING_ID}:onboarding-assign-user-roles-nav-click`,
  },

  hotspotInteraction: {
    activeOpportunitiesInfoIcon: `${PRO_ONBOARDING_ID}:onboarding-active-opportunities-info-icon-hotspot-click`,
    unhappyCallsChartSegment: `${PRO_ONBOARDING_ID}:onboarding-unhappy-calls-chart-segment-hotspot-click`,
    callInsightButton: `${PRO_ONBOARDING_ID}:onboarding-call-insight-button-hotspot-click`,
    transcriptTab: `${PRO_ONBOARDING_ID}:onboarding-transcript-tab-hotspot-click`,
    callBreakdownAccordion: `${PRO_ONBOARDING_ID}:onboarding-call-breakdown-accordion-hotspot-click`,
    makeCorrectionButton: `${PRO_ONBOARDING_ID}:onboarding-make-correction-button-hotspot-click`,
    callLevelFeedback: `${PRO_ONBOARDING_ID}:onboarding-call-level-feedback-hotspot-click`,
    followUpTasksTab: `${PRO_ONBOARDING_ID}:onboarding-follow-up-tasks-tab-hotspot-click`,
    schedulingTasksListButton: `${PRO_ONBOARDING_ID}:onboarding-scheduling-tasks-list-button-hotspot-click`,
    allFollowUpsListButtonFallback: `${PRO_ONBOARDING_ID}:onboarding-all-follow-ups-list-button-fallback-hotspot-click`,
    patientAvatar: `${PRO_ONBOARDING_ID}:onboarding-patient-avatar-hotspot-click`,
    lastCallCard: `${PRO_ONBOARDING_ID}:onboarding-last-call-card-hotspot-click`,
    viewHistoryButton: `${PRO_ONBOARDING_ID}:onboarding-view-history-button-hotspot-click`,
    settingsIcon: `${PRO_ONBOARDING_ID}:onboarding-settings-icon-hotspot-click`,
    userManagementNav: `${PRO_ONBOARDING_ID}:onboarding-user-management-nav-hotspot-click`,
  },
} as const;

export const CI_BASE_ONBOARDING_TRACKING_IDS = {
  bannerShowMeAroundClick: `${BASE_ONBOARDING_ID}:onboarding-banner-show-me-around-click`,
  bannerDismissClick: `${BASE_ONBOARDING_ID}:onboarding-banner-dismiss-click`,

  getStartedNavClick: `${BASE_ONBOARDING_ID}:onboarding-get-started-nav-click`,

  taskNavigationClick: {
    viewCallInsights: `${BASE_ONBOARDING_ID}:onboarding-view-call-insights-nav-click`,
    viewPatientContext: `${BASE_ONBOARDING_ID}:onboarding-view-patient-context-nav-click`,
    assignUserRoles: `${BASE_ONBOARDING_ID}:onboarding-assign-user-roles-nav-click`,
  },

  hotspotInteraction: {
    callsNavigation: `${BASE_ONBOARDING_ID}:onboarding-calls-navigation-hotspot-click`,
    callInsightButton: `${BASE_ONBOARDING_ID}:onboarding-call-insight-button-hotspot-click`,
    transcriptTab: `${BASE_ONBOARDING_ID}:onboarding-transcript-tab-hotspot-click`,
    patientAvatar: `${BASE_ONBOARDING_ID}:onboarding-patient-avatar-hotspot-click`,
    lastCallCard: `${BASE_ONBOARDING_ID}:onboarding-last-call-card-hotspot-click`,
    viewHistoryButton: `${BASE_ONBOARDING_ID}:onboarding-view-history-button-hotspot-click`,
    settingsIcon: `${BASE_ONBOARDING_ID}:onboarding-settings-icon-hotspot-click`,
    userManagementNav: `${BASE_ONBOARDING_ID}:onboarding-user-management-nav-hotspot-click`,
  },
} as const;

export function trackOnboardingEvent(eventName: string, properties?: pendo.Metadata) {
  pendo.track(eventName, {
    ...properties,
  });
}
